import { render, staticRenderFns } from "./EUR.vue?vue&type=template&id=5e0e8b38&scoped=true"
import script from "./EUR.vue?vue&type=script&lang=js"
export * from "./EUR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0e8b38",
  null
  
)

export default component.exports